import axios from 'axios';
import * as Cookies from '../utils/cookies';

export async function apiRemoveGoal(league_pk, round_pk, matchId, goalId) {
  const token = Cookies.getToken();

  try {
    const res = await axios({
      method: 'POST',
      url:
        process.env.REACT_APP_API_URL +
        `/api/league/leagues/${league_pk}/rounds/${round_pk}/matches/${matchId}/remove_goal/`,
      headers: { Authorization: `Bearer ${token}` },
      data: {
        goal_id: goalId,
      },
    });
    return res.data;
  } catch (error) {
    return { error: error };
  }
}

